<template>
  <path pid="0" d="M13 23.66a9 9 0 006.36-15.37L13.7 2.63a1 1 0 00-1.41 0L6.64 8.29A9 9 0 0013 23.66zM8.05 9.71l4.95-5 4.95 5a7 7 0 11-9.9 0z"/>
</template>
